import { Box, SimpleGrid, Stack, Text, VisuallyHidden } from '@chakra-ui/react';
import { Divider, gridConfig } from '@time-line/components/common';
import type { NavGroup } from '@time-line/components/types';

import { NewsletterSignup } from '../NewsletterSignup';
import { NavLink } from './NavLink';

const { gridGapClamp } = gridConfig;

interface NavProps {
  nav: NavGroup[];
  columns: number;
}

export function Nav({ nav, columns = 5 }: NavProps) {
  return (
    <Box className="footer_nav">
      <SimpleGrid role="presentation" columns={columns} gap={gridGapClamp}>
        {nav?.map(({ label }, i) => (
          <Stack gap="3xs" key={i} justifyContent="end">
            <Text as="h3" size="overline">
              {label}
            </Text>
            <Divider />
          </Stack>
        ))}
        <Stack gap="3xs" justifyContent="end">
          <Text as="h3" size="overline">
            Newsletter
          </Text>
          <Divider />
        </Stack>
      </SimpleGrid>
      <SimpleGrid columns={columns} gap={gridGapClamp} mt="2xs">
        {nav?.map(({ label, subNav }, i) => (
          <Box key={i}>
            <VisuallyHidden as="h3">{label}</VisuallyHidden>
            <Stack gap="5xs">
              {subNav &&
                subNav.items.map(
                  (item, j) =>
                    item.href && (
                      <NavLink
                        key={j}
                        href={item.href}
                        isExternal={
                          'isExternal' in item &&
                          (item as { isExternal?: boolean }).isExternal
                        }
                        label={item.label}
                        name={item.name}
                        platform="desktop"
                        showIcon={
                          'showIcon' in item &&
                          (item as { showIcon?: boolean }).showIcon
                        }
                      />
                    ),
                )}
            </Stack>
          </Box>
        ))}
        <Box>
          <VisuallyHidden as="h3">Sign up for our newsletter</VisuallyHidden>
          <NewsletterSignup key="newsletter" />
        </Box>
      </SimpleGrid>
    </Box>
  );
}
